import React from 'react';

const AboutFaceAI = () => {
    return (
        <nav style={{display:"flex", justifyContent:"flex-end"}}>
            <p className="f4 pa2 ma2 link dim fw4 grow pointer">About FaceAI</p>
        </nav>
    )
}
export default AboutFaceAI;